import { FormService } from './FormService';

export class BusinessSupportNcrService extends FormService {
    constructor() {
        super("BusinessSupportNcrs");
    } 
}